var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "goods-service-wrapper" },
    [
      _c(
        "div",
        { staticClass: "search-table" },
        [
          _c(
            "div",
            { staticClass: "filter-group" },
            [
              _c("el-input", {
                staticStyle: { width: "200px" },
                attrs: { clearable: "", placeholder: "Theo mã hàng hóa" },
                on: { clear: _vm.handleSearch },
                nativeOn: {
                  keyup: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    )
                      return null
                    return _vm.handleSearch.apply(null, arguments)
                  },
                },
                model: {
                  value: _vm.filters.itemCode,
                  callback: function ($$v) {
                    _vm.$set(_vm.filters, "itemCode", $$v)
                  },
                  expression: "filters.itemCode",
                },
              }),
              _c("el-input", {
                staticStyle: { width: "280px" },
                attrs: {
                  clearable: "",
                  placeholder: "Theo tên hàng hóa, dịch vụ",
                },
                on: { clear: _vm.handleSearch },
                nativeOn: {
                  keyup: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    )
                      return null
                    return _vm.handleSearch.apply(null, arguments)
                  },
                },
                model: {
                  value: _vm.filters.itemName,
                  callback: function ($$v) {
                    _vm.$set(_vm.filters, "itemName", $$v)
                  },
                  expression: "filters.itemName",
                },
              }),
            ],
            1
          ),
          _c(
            "el-button",
            {
              attrs: { type: "success", icon: "el-icon-plus" },
              on: { click: _vm.openCreateDialog },
            },
            [_vm._v("\n      Thêm hàng hóa, dịch vụ\n    ")]
          ),
        ],
        1
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          attrs: {
            data: _vm.rows,
            border: "",
            "element-loading-text": _vm.$tableLoading,
            "element-loading-spinner": "el-icon-loading",
            "element-loading-background": "rgba(255,255,255,0)",
            "header-cell-style": _vm.tableHeaderColor,
            "max-height": _vm.$tableMaxHeight,
            "empty-text": _vm.textTable,
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              type: "index",
              width: "60",
              align: "center",
              label: "STT",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          (_vm.filters.page - 1) * _vm.filters.limit +
                            scope.$index +
                            1
                        ) +
                        "\n      "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              prop: "itemCode",
              label: "Mã hàng hóa",
              "min-width": "130",
              align: "center",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "itemName",
              label: "Tên hàng hóa, dịch vụ",
              "min-width": "220",
              "show-overflow-tooltip": "",
            },
          }),
          _c("el-table-column", {
            attrs: { label: "Số lượng", "min-width": "100", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.formatQuantity(scope.row.quantity)) +
                        "\n      "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "Đơn giá", "min-width": "140", align: "right" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.formatCurrency(scope.row.unitPrice)) +
                        "\n      "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              prop: "unitName",
              label: "Đơn vị tính",
              "min-width": "120",
              align: "center",
            },
          }),
          _c("el-table-column", {
            attrs: { label: "Thuế GTGT", "min-width": "140", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.formatTaxLabel(scope.row)) +
                        "\n      "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              prop: "itemNote",
              label: "Ghi chú",
              "min-width": "220",
              "show-overflow-tooltip": "",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: "Tác vụ",
              width: "170",
              fixed: "right",
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-tooltip",
                      { attrs: { content: "Chi tiết", placement: "top" } },
                      [
                        _c("el-button", {
                          attrs: {
                            type: "primary",
                            size: "mini",
                            icon: "el-icon-view",
                            circle: "",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.openDetailDialog(scope.row)
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-tooltip",
                      { attrs: { content: "Chỉnh sửa", placement: "top" } },
                      [
                        _c("el-button", {
                          attrs: {
                            type: "warning",
                            size: "mini",
                            icon: "el-icon-edit",
                            circle: "",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.openEditDialog(scope.row)
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-tooltip",
                      { attrs: { content: "Xóa", placement: "top" } },
                      [
                        _c("el-button", {
                          attrs: {
                            type: "danger",
                            size: "mini",
                            icon: "el-icon-delete",
                            circle: "",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.handleDelete(scope.row)
                            },
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "pagination-wrapper" },
        [
          _c("el-pagination", {
            attrs: {
              "current-page": _vm.filters.page,
              "page-sizes": _vm.listSizeLimit,
              "page-size": _vm.filters.limit,
              layout: "prev, pager, sizes, next",
              total: _vm.totalRows,
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
              "update:currentPage": function ($event) {
                return _vm.$set(_vm.filters, "page", $event)
              },
              "update:current-page": function ($event) {
                return _vm.$set(_vm.filters, "page", $event)
              },
            },
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.dialogTitle,
            visible: _vm.dialogVisible,
            width: "680px",
            "append-to-body": "",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            close: _vm.handleDialogClose,
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "goodsForm",
              attrs: {
                model: _vm.form,
                rules: _vm.currentRules,
                "label-width": "140px",
                "label-position": "left",
              },
            },
            [
              _vm.dialogMode !== "create"
                ? _c(
                    "el-form-item",
                    { attrs: { label: "Mã hàng hóa" } },
                    [
                      _c("el-input", {
                        attrs: { value: _vm.form.itemCode, disabled: "" },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                { attrs: { label: "Tên hàng hóa", prop: "itemName" } },
                [
                  _c("el-input", {
                    attrs: { disabled: _vm.isDetailMode, maxlength: "255" },
                    model: {
                      value: _vm.form.itemName,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "itemName", $$v)
                      },
                      expression: "form.itemName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 12 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "Số lượng", prop: "quantity" } },
                        [
                          _c("el-input-number", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              disabled: _vm.isDetailMode,
                              precision: 2,
                              step: 0.01,
                              min: 0.01,
                            },
                            model: {
                              value: _vm.form.quantity,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "quantity", $$v)
                              },
                              expression: "form.quantity",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "Đơn vị tính", prop: "unitName" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                disabled: _vm.isDetailMode,
                                filterable: "",
                                "allow-create": "",
                                "default-first-option": "",
                                placeholder: "--Chọn đơn vị--",
                              },
                              on: { change: _vm.onUnitNameChange },
                              model: {
                                value: _vm.form.unitName,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "unitName", $$v)
                                },
                                expression: "form.unitName",
                              },
                            },
                            _vm._l(_vm.unitOptions, function (u) {
                              return _c("el-option", {
                                key: u,
                                attrs: { label: u, value: u },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 12 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "Đơn giá", prop: "unitPrice" } },
                        [
                          _c("el-input-number", {
                            staticStyle: { width: "100%" },
                            attrs: { disabled: _vm.isDetailMode },
                            model: {
                              value: _vm.form.unitPrice,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "unitPrice", $$v)
                              },
                              expression: "form.unitPrice",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: "Thuế GTGT", prop: "taxPercentage" },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                disabled: _vm.isDetailMode,
                                placeholder: "--Lựa chọn--",
                              },
                              on: { change: _vm.handleTaxChange },
                              model: {
                                value: _vm.form.taxPercentage,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "taxPercentage", $$v)
                                },
                                expression: "form.taxPercentage",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: { label: "Khác", value: "other" },
                              }),
                              _c("el-option", {
                                attrs: { label: "Không chịu thuế", value: -2 },
                              }),
                              _c("el-option", {
                                attrs: { label: "Không kê khai", value: -1 },
                              }),
                              _c("el-option", {
                                attrs: { label: "0%", value: 0 },
                              }),
                              _c("el-option", {
                                attrs: { label: "5%", value: 5 },
                              }),
                              _c("el-option", {
                                attrs: { label: "8%", value: 8 },
                              }),
                              _c("el-option", {
                                attrs: { label: "10%", value: 10 },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              String(_vm.form.taxPercentage) === "other"
                ? _c(
                    "el-row",
                    { attrs: { gutter: 12 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "Thuế khác (%)",
                                prop: "taxPercentageInput",
                              },
                            },
                            [
                              _c("el-input-number", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  disabled: _vm.isDetailMode,
                                  controls: false,
                                  min: 0,
                                  placeholder: "Nhập %",
                                },
                                model: {
                                  value: _vm.form.taxPercentageInput,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "taxPercentageInput",
                                      $$v
                                    )
                                  },
                                  expression: "form.taxPercentageInput",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                { attrs: { label: "Ghi chú", prop: "itemNote" } },
                [
                  _c("el-input", {
                    attrs: {
                      disabled: _vm.isDetailMode,
                      type: "textarea",
                      rows: 4,
                      maxlength: "500",
                      "show-word-limit": "",
                    },
                    model: {
                      value: _vm.form.itemNote,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "itemNote", $$v)
                      },
                      expression: "form.itemNote",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("Đóng")]
              ),
              !_vm.isDetailMode
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary", loading: _vm.actionLoading },
                      on: { click: _vm.handleSubmit },
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm.dialogMode === "create" ? "Tạo mới" : "Cập nhật"
                          ) +
                          "\n      "
                      ),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }